import React from "react";
import {
  ReferenceInput,
  SelectInput,
  required,
  Create,
  SimpleForm,
  TextInput
} from "react-admin";

// Validation function to ensure at least one code field is filled
const validateDistrict = (values) => {
  const errors = {};
  const codes = [
    "leagueCode",
    "conferenceCode",
    "divisionCode",
    "regionCode",
    "districtCode"
  ];
  const hasAtLeastOne = codes.some((code) => values[code]);

  if (!hasAtLeastOne) {
    codes.forEach((code) => {
      errors[code] = "At least one of these fields must be filled";
    });
  }

  return errors;
};

// Component for selecting sport code
const SportCodeInput = () => (
  <ReferenceInput label="Sport" source="sportCode" reference="sportCodes">
    <SelectInput
      optionText="label"
      optionValue="code"
      validate={[required()]}
    />
  </ReferenceInput>
);

// Component for selecting season code
const SeasonCodeInput = () => (
  <ReferenceInput
    label="Season"
    source="seasonCode"
    reference="availableSeasons"
  >
    <SelectInput
      optionText="label"
      optionValue="code"
      validate={[required()]}
    />
  </ReferenceInput>
);

// Main component for creating a district
const DistrictCreate = (props) => {
  const redirect = (basePath, id, data) => `/districts`;

  return (
    <Create {...props}>
      <SimpleForm validate={validateDistrict} redirect={redirect}>
        <SeasonCodeInput />
        <SportCodeInput />
        <TextInput
          source="leagueCode"
          parse={(value) => value.trim()}
          validate={[required()]}
        />
        <TextInput source="conferenceCode" parse={(value) => value.trim()} />
        <TextInput source="divisionCode" parse={(value) => value.trim()} />
        <TextInput source="regionCode" parse={(value) => value.trim()} />
        <TextInput source="districtCode" parse={(value) => value.trim()} />
        <TextInput
          source="label"
          validate={[required()]}
          parse={(value) => value.trim()}
        />
      </SimpleForm>
    </Create>
  );
};

export default DistrictCreate;
